/* NEXT PITCH — theme behaviour */
(function () {
  var doc = document;

  /* sticky header shadow */
  var header = doc.querySelector('.np-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* mobile drawer */
  var toggle = doc.querySelector('.np-menu-toggle');
  var drawer = doc.getElementById('np-drawer');
  if (toggle && drawer) {
    var setOpen = function (open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      doc.documentElement.classList.toggle('np-lock', open);
      doc.body.classList.toggle('np-lock', open);
    };
    toggle.addEventListener('click', function () { setOpen(!drawer.classList.contains('is-open')); });
    drawer.querySelectorAll('[data-np-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    drawer.querySelectorAll('.np-drawer__nav a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 700) setOpen(false); });
  }

  /* scroll reveal */
  var items = doc.querySelectorAll('.np-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* product gallery: thumbnails + prev/next arrows, with a soft crossfade */
  var gallery = doc.querySelector('.np-gallery');
  if (gallery) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-np-thumb]'));
    var activate = function (btn) {
      var main = gallery.querySelector('.np-gallery__main img');
      if (!main || !btn || btn.classList.contains('is-active')) return;
      main.style.opacity = '0';
      window.setTimeout(function () {
        var src = btn.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.setAttribute('src', src);
        main.setAttribute('alt', btn.getAttribute('data-alt') || '');
        main.style.opacity = '1';
      }, 120);
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    };
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn); });
    });
    gallery.querySelectorAll('[data-np-arrow]').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        if (thumbs.length < 2) return;
        var idx = thumbs.findIndex(function (b) { return b.classList.contains('is-active'); });
        if (idx === -1) idx = 0;
        var dir = arrow.getAttribute('data-np-arrow') === 'next' ? 1 : -1;
        activate(thumbs[(idx + dir + thumbs.length) % thumbs.length]);
      });
    });
  }

  /* mindset: line-by-line colour reveal, scrubbed to scroll on first pass only — once a line turns
     white it locks in and won't revert if the user scrolls back up */
  var mindsetLines = doc.querySelectorAll('.np-mindset__line');
  if (mindsetLines.length) {
    var mindsetTicking = false;
    var lerp = function (a, b, t) { return Math.round(a + (b - a) * t); };
    var updateMindsetLines = function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var startY = vh * 0.72;
      var endY = vh * 0.52;
      var allDone = true;
      mindsetLines.forEach(function (line) {
        if (line.dataset.npDone === '1') return;
        var rect = line.getBoundingClientRect();
        var mid = rect.top + rect.height / 2;
        var t = (startY - mid) / (startY - endY);
        t = Math.max(0, Math.min(1, t));
        var eased = 1 - Math.pow(1 - t, 3); /* ease-out: rushes to white, spends less time mid-grey */
        var v = lerp(17, 255, eased);
        line.style.color = 'rgb(' + v + ',' + v + ',' + v + ')';
        if (t >= 1) {
          line.dataset.npDone = '1';
          line.style.color = '#fff';
        } else {
          allDone = false;
        }
      });
      mindsetTicking = false;
      if (allDone) {
        window.removeEventListener('scroll', requestMindsetUpdate);
        window.removeEventListener('resize', requestMindsetUpdate);
      }
    };
    var requestMindsetUpdate = function () {
      if (!mindsetTicking) {
        window.requestAnimationFrame(updateMindsetLines);
        mindsetTicking = true;
      }
    };
    updateMindsetLines();
    window.addEventListener('scroll', requestMindsetUpdate, { passive: true });
    window.addEventListener('resize', requestMindsetUpdate);
  }

  /* accordion (product page: description / story / features / care / shipping) */
  doc.querySelectorAll('[data-np-accordion]').forEach(function (acc) {
    acc.querySelectorAll('.np-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.np-accordion__item');
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        trigger.setAttribute('aria-expanded', String(!open));
      });
    });
  });

  /* add to cart (ajax, then go to cart page) */
  var form = doc.querySelector('[data-np-product-form]');
  if (form) {
    var feedback = doc.querySelector('.np-form-feedback');
    var price = doc.querySelector('[data-np-price]');
    var dataEl = doc.querySelector('[data-np-variants]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (err) { variants = []; }
    var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: form.getAttribute('data-currency') || 'USD' });
    var groups = form.querySelectorAll('[data-np-option]');

    /* returns { variant } once every option is chosen, or { missing: 'Size' } */
    var findVariant = function () {
      if (!groups.length) return { variant: variants[0] };
      var chosen = [];
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var select = group.querySelector('select');
        var val;
        if (select) {
          val = select.value;
          if (!val) return { missing: group.getAttribute('data-name') || 'option' };
        } else {
          var c = group.querySelector('input:checked');
          if (!c) return { missing: group.getAttribute('data-name') || 'option' };
          val = c.value;
        }
        chosen.push(val);
      }
      var match = variants.filter(function (v) {
        return chosen.every(function (val, idx) { return v['option' + (idx + 1)] === val; });
      })[0];
      return { variant: match };
    };
    var refresh = function () {
      var r = findVariant();
      if (!r.variant || !price) return;
      var html = fmt.format(r.variant.price / 100);
      if (r.variant.compare_at_price && r.variant.compare_at_price > r.variant.price) html += '<s>' + fmt.format(r.variant.compare_at_price / 100) + '</s>';
      price.innerHTML = html;
    };
    form.addEventListener('change', function () { feedback.textContent = ''; refresh(); });
    refresh();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = findVariant();
      if (r.missing) { feedback.textContent = 'Choose a ' + r.missing.toLowerCase() + ' to add this to your lineup.'; return; }
      if (!r.variant || !r.variant.available) { feedback.textContent = 'Sorry, that combination is unavailable.'; return; }
      var btn = form.querySelector('button[type="submit"]');
      btn.disabled = true; feedback.textContent = '';
      fetch(window.routes ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(r.variant.id), quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart.');
          window.location.href = window.routes ? window.routes.cart_url : '/cart';
        })
        .catch(function (err) { feedback.textContent = err.message; btn.disabled = false; });
    });
  }
})();
